import * as Html from "../util/Html.ts";
import TPL from "../form/giphy-preview.mustache";
export {init}
Html.registerWidget('widget/giphy-preview',{init:init})

Html.register({
  gifremove:function(url,preview){
    this.parents("[data-widget='widget/giphy-preview']").html('')
  }
})


function init(node){
  node.on('change',function(evt,data){
    if(data){
      node.show();
      Html.setHtml(node,TPL,data)
    }else{
      this.hide();
      node.html('');
    }
  })
}